var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAiLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CAE9F7"
    },
    d: "M255.999,157.309c-4.688,0-8.488-5.33-8.488-11.904V85.625c0-6.575,3.801-11.904,8.488-11.904 c4.688,0,8.488,5.33,8.488,11.904v59.778C264.488,151.978,260.687,157.309,255.999,157.309z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#578CAD"
    },
    cx: 255.997,
    cy: 56.36,
    r: 40.381
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#578CAD"
    },
    d: "M330.029,139.362H181.97c-11.153,0-20.19,9.038-20.19,20.19v15.702h188.439v-15.702 C350.219,148.401,341.179,139.362,330.029,139.362z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#231F20",
      enableBackground: "new"
    },
    d: "M233.622,56.36c0-19.206,13.412-35.269,31.379-39.36 c-2.896-0.66-5.904-1.02-9-1.02c-22.303,0-40.381,18.078-40.381,40.38c0,22.301,18.078,40.38,40.381,40.38 c3.095,0,6.104-0.36,9-1.02C247.033,91.627,233.622,75.565,233.622,56.36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#231F20",
      enableBackground: "new"
    },
    d: "M199.972,139.362h-18.001c-11.153,0-20.19,9.038-20.19,20.19 v15.702h18.002v-15.702C179.783,148.401,188.819,139.362,199.972,139.362z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#578CAD"
    },
    d: "M301.233,496.021H198.232c-11.149,0-20.191-9.041-20.191-20.19v-11.216 c0-11.15,9.041-20.19,20.191-20.19h115.53c11.153,0,20.191,9.04,20.191,20.19v11.216c0,11.15-9.038,20.19-20.191,20.19H301.233"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#231F20",
      enableBackground: "new"
    },
    d: "M196.043,475.831v-11.216c0-11.15,9.041-20.19,20.191-20.19 h-18.001c-11.149,0-20.191,9.04-20.191,20.19v11.216c0,11.15,9.041,20.19,20.191,20.19h18.001 C205.084,496.021,196.043,486.98,196.043,475.831z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#578CAD"
    },
    d: "M55.244,244.798C24.706,244.973,0,273.772,0,309.284s24.706,64.311,55.244,64.488V244.798z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#578CAD"
    },
    d: "M456.756,244.798C487.291,244.973,512,273.773,512,309.285s-24.709,64.311-55.244,64.488V244.798z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#90C8EC"
    },
    d: "M438.83,174.124H133.73h-28.294H73.167c-11.151,0-20.191,9.04-20.191,20.19v232.185 c0,11.151,9.04,20.19,20.191,20.19H438.83c11.149,0,20.189-9.04,20.189-20.19V194.314 C459.019,183.163,449.98,174.124,438.83,174.124z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#CAE9F7"
    },
    cx: 161.777,
    cy: 269.466,
    r: 24.676
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#CAE9F7"
    },
    cx: 350.218,
    cy: 269.466,
    r: 24.676
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CAE9F7"
    },
    d: "M312.082,373.78c0,11.15-9.038,20.19-20.191,20.19h-71.787c-11.15,0-20.191-9.04-20.191-20.19 v-16.825c0-11.15,9.04-20.19,20.191-20.19h71.787c11.153,0,20.191,9.04,20.191,20.19V373.78z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#231F20",
      enableBackground: "new"
    },
    d: "M18.002,309.284c0-25.499,10.143-48.232,25.988-63.092 C18.86,252.359,0,278.259,0,309.284c0,31.027,18.86,56.926,43.99,63.092C28.145,357.516,18.002,334.784,18.002,309.284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#231F20",
      enableBackground: "new"
    },
    d: "M70.98,426.498V194.314c0-11.15,9.038-20.19,20.191-20.19 H73.167c-11.151,0-20.191,9.04-20.191,20.19v232.185c0,11.151,9.04,20.19,20.191,20.19h18.002 C80.018,446.689,70.98,437.649,70.98,426.498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#231F20",
      enableBackground: "new"
    },
    d: "M155.105,269.465c0-10.451,6.5-19.378,15.676-22.975 c-2.79-1.093-5.823-1.701-9-1.701c-13.63,0-24.678,11.048-24.678,24.676c0,13.628,11.048,24.676,24.678,24.676 c3.177,0,6.21-0.608,9-1.701C161.604,288.843,155.105,279.916,155.105,269.465z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#231F20",
      enableBackground: "new"
    },
    d: "M343.544,269.465c0-10.451,6.5-19.378,15.677-22.975 c-2.79-1.093-5.825-1.701-9.001-1.701c-13.63,0-24.677,11.048-24.677,24.676c0,13.628,11.047,24.676,24.677,24.676 c3.177,0,6.211-0.608,9.001-1.701C350.044,288.843,343.544,279.916,343.544,269.465z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#231F20",
      enableBackground: "new"
    },
    d: "M217.916,373.78v-16.825c0-11.15,9.041-20.19,20.191-20.19 h-18.001c-11.15,0-20.191,9.04-20.191,20.19v16.825c0,11.15,9.04,20.19,20.191,20.19h18.001 C226.957,393.97,217.916,384.93,217.916,373.78z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiLogo);
export default __webpack_public_path__ + "static/media/AILogo.399922208eb694436bb85d4c0f948893.svg";
export { ForwardRef as ReactComponent };